import { placesManagementLoadAction } from 'places-fwk-actions';
import { orchestrator } from 'satcheljs';
import {
    PlacesManagementLoadE2ECheckmark,
    PlacesManagementLoadE2EComplete,
    PlacesManagementLoadE2EStart,
} from '../placesManagementLoadE2E';

type SourceTypes = Parameters<typeof PlacesManagementLoadE2ECheckmark>[0];

orchestrator(placesManagementLoadAction, ({ scenario, errorObject, adminRoles }) => {
    let source: SourceTypes | undefined = undefined;
    let reason: string | undefined = undefined;

    let shouldEndSuccessMarker = false;

    switch (scenario) {
        case 'PlacesManagementLoadStart':
            PlacesManagementLoadE2EStart();
            return;
        case 'BundleLoaded':
            source = 'bl';
            break;
        case 'BannerShown':
            source = 'bs';
            break;
        case 'BuildingsLoaded':
            source = 'blds';
            reason = 'complete-because-buildings-loaded';
            shouldEndSuccessMarker = true;
            break;
        case 'NoBuildings':
            source = 'blds';
            reason = 'complete-because-no-buildings';
            shouldEndSuccessMarker = true;
            break;
        case 'BuildingLoadFailed':
            source = 'bldsf';
            reason = 'complete-because-building-load-failed';
            shouldEndSuccessMarker = true;
            break;
        case 'PermissionChecked':
            source = 'pc';
            break;
        case 'PermissionCheckFailed':
            source = 'pcf';
            break;
        case 'PermissionCheckFromCache':
            source = 'pcfc';
            break;
        case 'NoPermissionPageShown':
            source = 'nps';
            reason = 'complete-because-no-permission';
            shouldEndSuccessMarker = true;
            break;
    }

    if (source != null) {
        PlacesManagementLoadE2ECheckmark(source);
    }

    if (errorObject) {
        // If there is an error object, we log it as a failure
        PlacesManagementLoadE2EComplete(false, reason, source, errorObject);
        return;
    }

    if (shouldEndSuccessMarker) {
        PlacesManagementLoadE2EComplete(true, reason, undefined, undefined, adminRoles);
    }
});
